import Badge, { DangerBadge, DefaultBadge, InfoBadge, SuccessBadge, WarningBadge } from './template';
export default Badge;
export { DangerBadge, DefaultBadge, InfoBadge, SuccessBadge, WarningBadge };
